import { createFileRoute } from "@tanstack/react-router";
import { AgentApp } from "./AgentApp";

export const Route = createFileRoute("/agent/$")({
  component: AgentMfePage,
});

function AgentMfePage() {
  return <AgentApp />;
}
